module.exports = __webpack_public_path__ + "img/stace.5b2e9ebf.jpeg";